import { useEffect, useSyncExternalStore } from "react";
import { api, API } from "@/lib/api";

const DEFAULTS = { logo_light: "/zola-logo-full.webp", logo_dark: "/zola-logo-dark.webp", custom: {} };
let state = DEFAULTS;
let loaded = false;
const subs = new Set();

export const logoSrc = (p) => (p?.startsWith("/api/") ? `${API.replace(/\/api$/, "")}${p}` : p);

export function setBranding(data) {
  state = { ...DEFAULTS, ...data };
  subs.forEach((f) => f());
}

export function refreshBranding() {
  loaded = true;
  return api.get("/public/branding").then(({ data }) => setBranding(data)).catch(() => {});
}

// Site-wide logos shared by the website, portal and admin headers
export function useBranding() {
  useEffect(() => { if (!loaded) refreshBranding(); }, []);
  return useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => state);
}
